export default "__VITE_ASSET__A0bl6L_9__"